import { createFileRoute } from '@tanstack/react-router';
import { NotificationsPage, merchantNotificationsInfiniteQueryOptions } from '@/features/notifications';

export const Route = createFileRoute('/_authed/notifications')({
  loader: ({ cause, context }) => {
    if (cause !== 'enter') return;
    void context.queryClient.prefetchInfiniteQuery(merchantNotificationsInfiniteQueryOptions());
  },
  component: NotificationsRouteComponent,
});

function NotificationsRouteComponent() {
  return <NotificationsPage />;
}
